
export { NavSearchEmployeeResultTypeComponent } from './employee-result-type.component';
